<template>
    <div>
        <div id="mapContainer"></div>
    </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet-gpx/gpx.js";
import "leaflet/dist/images/marker-shadow.png";
import L from "leaflet";
import * as turf from "@turf/turf";
export default {
    components: {},
    props: ["lines", "coureur", "focus_point"],
    data() {
        return {
            map: {},
            list_marker_points: [],
            marker_coureur: {},
            focus_marker: {},
            line: [],
            icons: [],
            fond_carte: {},
        };
    },
    computed: {
        gpx_url() {
            return "https://sportips.fr/live/" + this.coureur.parcours.trace;
        },
    },
    watch: {
        "$store.state.map_settings.selected_mode": function () {
            this.fond_carte.setUrl(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link);
        },
        coureur: function (newVal, oldVal) {
            this.displayCoureur();
        },
        lines: function (newVal, oldVal) {
            if (this.lines) {
                this.line = turf.lineString(newVal);
                this.displayPoints();
            }
        },
        focus_point: function (newVal, oldVal) {
            // watch it
            if (Object.keys(this.focus_marker).length === 0) {
                var options = {
                    units: "kilometers",
                };
                var point_coordinates = turf.along(this.line, this.focus_point, options);

                this.focus_marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
                    title: "focus",
                    icon: this.icons["focus"],
                });
                this.focus_marker.addTo(this.map);
            } else {
                if (this.focus_point === 0) {
                    this.map.removeLayer(this.focus_marker);
                    this.focus_marker = {};
                } else {
                    var point_coordinates = turf.along(this.line, this.focus_point, options);
                    this.focus_marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
                }
            }
        },
    },

    methods: {
        displayPoints: function () {
            for (var i = 0; i < this.list_marker_points.length; i++) {
                this.map.removeLayer(this.list_marker_points[i]);
            }
            this.list_marker_points = [];
            var options = {
                units: "kilometers",
            };
            for (var i = 0; i < this.coureur.passages.list.length; i++) {

                var point = this.coureur.passages.list[i];
                if (point.nom == 'Départ' || point.nom == 'Arrivée') {
                    continue;
                }
                var point_coordinates = turf.along(this.line, parseFloat(point.distance_depuis_depart), options);
                var marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
                    title: point.nom_affiche,
                    icon: this.icons["point"],
                });
                this.list_marker_points.push(marker);
                marker.addTo(this.map);
            }
        },
        defineMarker: function () {
            var options = {
                units: "kilometers",
            };
            var point_coordinates = turf.along(this.line, 0, options);

            this.marker_coureur = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
                title: this.coureur.identite.dossard,
                icon: this.icons["coureur"],
            });
            this.marker_coureur.addTo(this.map);
        },
        displayCoureur: function () {
            var options = {
                units: "kilometers",
            };
            var point_coordinates;
            if (!this.coureur.statut.pris_depart || !this.coureur.statut_course.start) {
                point_coordinates = turf.along(this.line, 0, options);
                this.marker_coureur.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
            } else if (this.coureur.statut.arrivee || this.coureur.statut_course.end) {
                point_coordinates = turf.along(this.line, parseFloat(this.coureur.parcours.nb_km), options);
                this.marker_coureur.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
            } else {
                if (!this.coureur.estimation) return;
                if (this.coureur.estimation.trackingMethod === "estimation") {
                    if (this.coureur.estimation.distance) {
                        point_coordinates = turf.along(this.line, this.coureur.estimation.distance, options);
                        this.marker_coureur.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
                    }
                } else {
                    if (this.coureur.estimation.position) {

                        this.marker_coureur.setLatLng([this.coureur.estimation.position[0], this.coureur.estimation.position[1]]);
                    }

                }
            }
        },

        initMap() {
            var _this = this;
            this.map = L.map("mapContainer", {
                zoomControl: false,
                dragging: !L.Browser.mobile,
                tap: !L.Browser.mobile,
            });
            this.map.setView([0, 0], 13);
            this.fond_carte = L.tileLayer(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link, {
                zoomControl: false,
                maxZoom: 17,
                attribution:
                    'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
            }).addTo(this.map);

            this.gpx = new L.GPX(this.gpx_url, {
                polyline_options: {
                    color: "#F03A47",
                    opacity: 0.9,
                    weight: 2,
                    lineCap: "round",
                },
                async: true,
                marker_options: {
                    wptIconUrls: {
                        "": "https://sportips.fr/live/includes/img/wp.png",
                    },
                    startIconUrl: "https://sportips.fr/live/includes/img/pin-start.png",
                    endIconUrl: "https://sportips.fr/live/includes/img/pin-end.png",
                },
            })
                .on("loaded", function (e) {
                    _this.map.fitBounds(e.target.getBounds());
                })
                .addTo(this.map);
        },
        setIcons: function () {
            this.icons["coureur"] = new L.DivIcon({
                className: "coureur-icon",
                html:
                    "<div class='pin_runner_profil_container_map'><img class='pin_runner_profil_map' src='https://sportips.fr/live/includes/img/pin-runner-2.png'/><span class='pin_runner_content_map'>" +
                    this.coureur.identite.nom.charAt(0).toUpperCase() +
                    this.coureur.identite.prenom.charAt(0).toUpperCase() +
                    "</span></div>",
                iconAnchor: [17, 40],
            });
            this.icons["focus"] = L.icon({
                iconUrl: "https://sportips.fr/live/includes/img/focus_point.png",
                iconSize: [15, 15],
                iconAnchor: [7, 7],
            });
            this.icons["point"] = L.icon({
                iconUrl: "https://sportips.fr/live/includes/img/pin-checkpoint-before.png",
                iconSize: [24, 37],
                iconAnchor: [12, 37],
            });
        },
    },
    mounted() {
        this.setIcons();
        this.initMap();
        this.line = turf.lineString(this.lines);
        this.displayPoints();
        this.defineMarker();
        this.displayCoureur();
    },
};
</script>

<style>
.pin_runner_profil_map {
    position: absolute;

    width: 30px;
}

.pin_runner_profil_container_map {
    font-weight: bold;
    padding: 0 2px;
    width: 50px;
}

.pin_runner_content_map {
    position: absolute;

    top: 9px;
    left: 9px;
    color: white;
}
</style>
